import JustValidate from 'just-validate';

const registrationForm = document.getElementById('registration_form');
const validator = new JustValidate('#registration_form');
window.onload = function () {
  validator
    .addField('#name', [
      {
        rule: 'required',
        errorMessage: 'Ime je obavezno',
      },
    ])
    .addField('#lastname', [
      {
        rule: 'required',
        errorMessage: 'Prezime je obavezno',
      },
    ])
    .addField('#email', [
      {
        rule: 'required',
        errorMessage: 'E-mail je obavezan',
      },
      {
        rule: 'email',
        errorMessage: 'Email adresa koju ste uneli je nevažeća.',
      },
    ])

    .addField('#phone', [
      {
        validator: (value) => {
          if (phoneNotificationCheckbox.checked) {
            return value.trim() !== ''; // must not be empty if checked
          }
          return true; // not required if unchecked
        },
        errorMessage: 'Telefon je obavezan',
      },
    ])

    .addField('#register-terms', [
      {
        rule: 'required',
        errorMessage: 'Ovo je obavezno polje.',
      },
    ])
    .addField('#register-privacy', [
      {
        rule: 'required',
        errorMessage: 'Ovo je obavezno polje.',
      },
    ])
    .addField('#password', [
      {
        rule: 'required',
        errorMessage: 'Lozinka je obavezna',
      },
      {
        rule: 'minLength',
        value: 8,
        errorMessage: 'Lozinka mora da ima minimalno 8 karaktera.',
      },
    ])
    .addField('#password-confirmation', [
      {
        rule: 'required',
        errorMessage: 'Lozinka je obavezna',
      },
      {
        rule: 'minLength',
        value: 8,
        errorMessage: 'Lozinka mora da ima minimalno 8 karaktera.',
      },
      {
        validator: (value, fields) => {
          if (
            fields['#password'] &&
            fields['#password'].elem
          ) {
            const repeatPasswordValue =
              fields['#password'].elem.value;

            return value === repeatPasswordValue;
          }

          return true;
        },
        errorMessage: 'Lozinke se ne podudaraju. Pokušajte ponovo.',
      },
    ]).onSuccess((() => {
      registrationForm.submit()
    })).onFail((() => {
      registrationForm.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'start' });
    }))
};

// Make password visible
const seePassword = document.querySelector(".js_see_password");
const passwordInput = document.querySelector(".js_password");
const passwordInputConfirmation = document.querySelector(".js_password_confirmation");

if (seePassword) {
  seePassword.addEventListener('click', () => {
    if (passwordInput.getAttribute("type") === "password") {
      passwordInput.setAttribute("type", "text");
      passwordInputConfirmation.setAttribute("type", "text");
      seePassword.classList.add('visible');
    } else {
      passwordInput.setAttribute("type", "password");
      passwordInputConfirmation.setAttribute("type", "password");
      seePassword.classList.remove('visible');
    }
  })
}



// Toggle Phone number data
const togglePhoneNotificationButton = document.getElementById("accept_phone_notification_btn");
const phoneNotificationCheckbox = document.getElementById("accept_phone_notification");
const phoneNotificationData = document.getElementById("phone_notification_data");

togglePhoneNotificationButton.addEventListener("click", function (e) {
  // Prevent checkbox default toggle
  e.preventDefault();

  // Manually toggle checkbox state
  phoneNotificationCheckbox.checked = !phoneNotificationCheckbox.checked;

  // Toggle max-height animation
  phoneNotificationData.classList.toggle('max-h-0');
  phoneNotificationData.classList.toggle('max-h-[400px]');
});

// Toggle Privilege data
const toggleButton = document.getElementById("privilege_data_btn");
const privilegeCheckbox = document.getElementById("privilege-club");
const privilegeData = document.getElementById("privilege_data");

toggleButton.addEventListener("click", function (e) {
  // Prevent checkbox default toggle
  e.preventDefault();

  // Manually toggle checkbox state
  privilegeCheckbox.checked = !privilegeCheckbox.checked;

  // Toggle max-height animation
  privilegeData.classList.toggle('max-h-0');
  privilegeData.classList.toggle('max-h-[400px]');
});
